function initCustomFields(form) {
	const textFields = form.querySelectorAll('.mdc-text-field');
	const checkboxes = form.querySelectorAll('.mdc-checkbox');
	const radios = form.querySelectorAll('.mdc-radio');
	const selects = form.querySelectorAll('.mdc-select');
	const switches = form.querySelectorAll('.mdc-switch');
	const sliders = form.querySelectorAll('.mdc-slider');

	textFields.forEach(element => {
		element.MDCTextField = new window.MDCTextField(element);
	});

	checkboxes.forEach(element => {
		const input = new window.MDCCheckbox(element);
		const formField = new window.MDCFormField(element.closest('.mdc-form-field'));

		formField.input = input;
	});

	radios.forEach(element => {
		const input = new window.MDCRadio(element);
		const formField = new window.MDCFormField(element.closest('.mdc-form-field'));

		formField.input = input;
	});

	selects.forEach(element => {
		element.MDCSelect = new window.MDCSelect(element);
	});

	switches.forEach(element => {
		new window.MDCSwitch(element);
	});

	sliders.forEach(element => {
		const slider = new window.MDCSlider(element);

		// Sync with (hidden) input
		const customWrapper = element.closest('._mdc-slider-wrapper');

		if (customWrapper) {
			const input = customWrapper.querySelector('input');

			slider.foundation_.adapter_.setMarkerValue(input.value);

			input.addEventListener(
				'input',
				event => {
					const { value } = event.target;

					slider.value = value;
					slider.foundation_.adapter_.setMarkerValue(value);
				},
				false
			);

			// Work around rendering issues when used in embedded apps
			setTimeout(() => {
				slider.layout();
			}, 100);
		}

		// Expose
		element.MDCSlider = slider;
	});
}

// Expose in global namespace so we can use it in embedded apps
window.LN = window.LN || {};
window.LN.initCustomFields = initCustomFields;

export { initCustomFields };
